module.exports = __webpack_public_path__ + "static/media/twitter.5c3632d0.svg";